// extracted by mini-css-extract-plugin
export default {"wrapper":"Button_wrapper__S3G-D","buttonText":"Button_buttonText__ppVU0"};